<template>
  <div>404 Foo vite js</div>
</template>
